









import { Component, Prop, Mixins } from 'vue-property-decorator';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import PersonData from '@/ts/PersonData';

@Component
export default class ParticipantIcon extends Mixins(DeviceMethods) {
    @Prop() public personId!: number;
    @Prop() public participantCount!: number;

    constructor() {
        super();
    }

    get person(): PersonData {
        const user = this.$store.getters['User/getCacheUser'](this.personId);

        if (user.fetchedMiniature === false) {
            user.fetchMiniature(this.$store);
            user.fetchedMiniature = true;
        }

        return user;
    }
}
